

define(['jquery', 'squid/module', 'text!./template.html', 'components/angular-ui-utils/ui-utils.min', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index', 'components/xo-models/src/address/index', 'components/xo-address-components/src/add-address/directive', 'components/xo-page-components/src/aside-header/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-ui-components/src/accessibility/directive'], function ($, module, template) {

    return module('xo-add-card.addbilling.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address', 'xo-add-address.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive']).directive('xoAddBilling', function () {

        return {
            template: template,

            scope: {
                auth: '=',
                token: '=',
                doneFn: '=',
                parentCallbacks: '=',
                sidebar: '=',
                showmeftsection: '=',
                hideparenthead: '=',
                billingaddressupdated: '=',
                prefillAddress: '='
            },

            controller: function controller($scope, $populate, $BillingAddressesModel, $BillingAddressModel, $PrefillAddressModel, $feature, $state, $element, $config, $locale, $timeout) {
                var country = $locale.getCountryCodeISO();
                $scope.billing = true; // to denote its billing address page still
                $scope.normalize = $feature('addressNormalization');
                $scope.country = country;
                var $el = $($element);
                if ($scope.showmeftsection) {
                    $scope.showmeftsection.toggle = false;
                }

                if ($scope.hideparenthead) {
                    $scope.hideparenthead.toggle = true;
                }

                function isUserInputtedAddress(address) {
                    return address.id === '0';
                }

                // Label fields has having error if needed to, and focus the first error if needed
                function handleValidation(res) {
                    if (res && res.fields && res.fields.length) {
                        res.fields.forEach(function (field) {
                            if (field.field) {
                                var $field = $($el.find('[name="' + field.field + '"]'));
                                if ($field.length === 0 && field.field === 'zip') {
                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                                }

                                $field.addClass('backendError');
                                $field.attr('aria-invalid', true);
                            }
                        });
                    }

                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
                }

                var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;

                if (prefilledAddress) {
                    $scope.prefilled = true;
                }

                $scope.address = $scope.address || prefilledAddress || { country: country };

                $populate($scope, {
                    billingAddresses: $BillingAddressesModel.instance()
                }).then(function () {

                    $scope.cancelFn = function () {
                        $state.go('^.addCard');
                    };

                    $scope.onSubmit = function () {
                        $scope.updateAddress();
                    };

                    $scope.prefill = function () {
                        $scope.address.country = $scope.country;
                        $scope.prefillAddress = new $PrefillAddressModel({
                            id: $scope.token,
                            address: $scope.address
                        });

                        $scope.prefillAddress.save({
                            data: $scope.prefillAddress,

                            success: function success(result) {
                                $scope.address = result;
                                $scope.prefilled = true;
                                $scope.showAddressFields = true;

                                $timeout(function () {
                                    var value = $scope.address.state;

                                    var $option = $el.find('[value="' + value + '"]');
                                    $option.prop('selected', 'selected');
                                    $option.trigger('change');

                                    value = $option.attr('label');
                                }, 1000);
                            }
                        });
                    };

                    $scope.updateAddress = function () {

                        var newBilling = new $BillingAddressModel({
                            line1: $scope.address.line1,
                            line2: $scope.address.line2,
                            city: $scope.address.city,
                            state: $scope.address.state,
                            postal_code: $scope.address.postal_code,
                            normalization_status: $scope.address.normalization_status,
                            country: country,
                            id: '0'
                        });

                        newBilling.save({
                            data: $scope.billingAddress,

                            success: function success() {
                                if ($scope.normalize) {
                                    // set to false so that html related to billing address is hidden when child is shown
                                    $scope.billing = false;
                                    $scope.address.full_address = newBilling.full_address;
                                    $state.go('.addressNormalization');
                                } else {
                                    $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
                                }
                            },

                            validation: function validation(res) {
                                handleValidation(res);
                            }

                        });
                    };

                    $scope.uponNormalization = function (normalizedAddress, isBack) {
                        if (isBack) {
                            $scope.billing = true;
                            $state.go('^');
                        } else {
                            $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
                        }
                    };

                    $scope.updateBillingAddressAndReturn = function (target, address) {
                        var newBillingAddress;
                        if (address && address instanceof $BillingAddressModel) {
                            newBillingAddress = address;
                        } else {
                            newBillingAddress = new $BillingAddressModel({
                                line1: address.line1,
                                line2: address.line2,
                                city: address.city,
                                state: address.state,
                                postal_code: address.postal_code,
                                normalization_status: address.normalization_status,
                                country: address.country || $scope.country,
                                full_address: address.full_address || $scope.address.full_address,
                                id: '0'
                            });
                        }

                        var addresses = $scope.billingAddresses.addresses;
                        if (!isUserInputtedAddress(addresses[0])) {
                            addresses.unshift(newBillingAddress);
                        } else {
                            addresses[0] = newBillingAddress;
                        }
                        $scope.billingaddressupdated.value = true;

                        $state.go(target);
                    };
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-card/addbilling/directive.js
 ** module id = 285
 ** module chunks = 1
 **/